import React from 'react';
import NoOrderOnOrderListImage from '@assets/no-order-orderlist.svg';
import style from './DashboardEmptyOrderList.module.scss';
import PIEText from '@src/shared/components/PIEText';
import { useTranslation } from 'react-i18next';
export const DashboardEmptyOrderList = () => {
  const { t } = useTranslation();
  return (
    <div className={style.DashboardEmptyOrderListContainer}>
      <img src={NoOrderOnOrderListImage} />
      <div className={style.title}>
        <PIEText
          size="var(--xds-font-size-20)"
          align="left"
          text={t('order.empty_list_title')}
          fontWeight="var(--xds-font-weight-bold)"
        ></PIEText>
      </div>
      <div>
        <PIEText
          size="var(--xds-font-size-16)"
          align="center"
          text={t('order.empty_list_description')}
          fontWeight="var(--xds-font-weight-regular)"
        ></PIEText>
      </div>
    </div>
  );
};

export default DashboardEmptyOrderList;
